import { useTranslation } from "react-i18next";

/**
 * SubmittedScreen — 提出済みの回答者が再度リンクを踏んだ場合の案内画面。
 *
 * ADR-0024: token 消費済みでも respondent.Status===completed なら Cookie 発行の上
 * SPA まで到達させる (05-auth.md §5.4)。SPA 側は GET /api/respondent-questionnaire /
 * POST /api/respondent-answers いずれかの結果で status==="completed" を検知したら本画面を出す。
 * ThanksScreen (提出直後の遷移) とは文脈が違う (再訪 vs 送信直後) ため文言を分ける。
 */
export function SubmittedScreen() {
  const { t } = useTranslation("respond");
  return (
    <section className="space-y-6">
      <header className="space-y-1">
        <h2 className="text-base font-semibold">{t("submitted.title")}</h2>
        <p className="text-sm text-muted-foreground">{t("submitted.description")}</p>
      </header>
      <div className="rounded-md border border-border bg-muted/40 p-4 text-sm text-muted-foreground">
        {t("submitted.notice")}
      </div>
    </section>
  );
}
